import React from "react";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import DatePicker from "../../../../../../components/form/DateTime";
import CroField from "../../../generalForm/CroField";
import CroPriceField from "../../../generalForm/CroPriceField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import {
  fieldsRemove,
  importNumWithComma,
  exportNumWithDot,
} from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

const inRange0100 = V.inRange(0, 100);

export default ({
  fields,
  disabled,
  noPublicLogged,
  dos,
  ongoing,
  wps,
  t,
  deputyStatement,
  point3,
  ingoing,
  defaultCountry,
  isLogged,
  outgoing,
  onICOChange,
  aresErrors,
  versionChangedClass
}) => {
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index) => (
        <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ""}`}>
          <ItemNumber index={index} />
          {!disabled && fields.length > 1 && (
              <CroRemoveButton onClick={() => removeItem(index)} />
          )}
          <div className="cro-array-item-content">
            <div className="statementForm__arrayGrid">
              <div>
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.identificationNumber`) : ""}
                  title="IČO"
                  name={`${item}.identificationNumber`}
                  component={IcoInput}
                  disabled={disabled}
                  validate={[V.required, V.isNumeric]}
                  helpEnum={H[`${t}CS_IDENTIFICATION_NUMBER`].r}
                  onICOChange={(val) => onICOChange && onICOChange(index, val)}
                />
                {aresErrors && aresErrors[index] && (
                  <span className="cro-ares-error">{aresErrors[index]}</span>
                )}
              </div>

              <CroField
                className={versionChangedClass ? versionChangedClass(`${item}.name`) : ""}
                title="Obchodní firma/název obchodní korporace"
                name={`${item}.name`}
                component={Input}
                disabled={disabled}
                validate={[V.required]}
                helpEnum={H[`${t}CS_NAME`].r}
                maxlen={1000}
              />

              {dos && (outgoing || ongoing) && (
                <CroPriceField
                  className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                  title="Hodnota obchodního podílu"
                  name={`${item}.price`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.isNumeric]}
                  helpEnum={H[`${t}CS_PRICE`].r}
                />
              )}

              {!deputyStatement && !dos && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.shareAmount`) : ""}
                  title="Velikost podílu v %"
                  name={`${item}.shareAmount`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required, inRange0100]}
                  normalize={exportNumWithDot}
                  format={importNumWithComma}
                />
              )}

              {!point3 && wps > 1 && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.acquisitionDate`) : ""}
                  title="Datum nabytí"
                  name={`${item}.acquisitionDate`}
                  component={DatePicker}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}

              {isLogged && (
                <p className="statementForm__arrayLabel">
                  Sídlo obchodní korporace{" "}
                  <Help helpEnum={H[`${t}CS_ADDRESS`].r} disabled={disabled} />
                </p>
              )}

              {isLogged && (
                <CroCountry
                  className={versionChangedClass ? versionChangedClass(`${item}.address.country`) : ""}
                  title="Stát"
                  name={`${item}.address`}
                  disabled={disabled}
                  form="statementForm"
                  validate={[V.required]}
                  defaultCountry={defaultCountry}
                />
              )}
              {isLogged && (
                <CroMunicipality
                  className={versionChangedClass ? versionChangedClass(`${item}.address.municipality`) : ""}
                  title="Obec"
                  name={`${item}.address`}
                  disabled={disabled}
                  form="statementForm"
                  validate={[V.required]}
                />
              )}

              {isLogged && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.address.street`) : ""}
                  title="Ulice"
                  name={`${item}.address.street`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}
              {isLogged && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.address.orientationNumber`) : ""}
                  title="Č.p./Č.o."
                  name={`${item}.address.orientationNumber`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                  helpEnum={H.HOUSE_NUMBER.r}
                />
              )}

              {isLogged && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.address.zip`) : ""}
                  title="PSČ"
                  name={`${item}.address.zip`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}

              {(!dos || (dos && (outgoing || ongoing))) && noPublicLogged && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.ownership`) : ""}
                    title="Vlastnictví"
                    name={`${item}.ownership`}
                    component={AutoComplete}
                    disabled={disabled}
                    fullWidth
                    url="/api/ciselniky/zpusob-vlastnictvi"
                    validate={[V.isDictionary]}
                  />
                </div>
              )}

              {noPublicLogged && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                    title="Poznámka"
                    name={`${item}.note`}
                    component={Input}
                    disabled={disabled}
                    multiline
                    helpEnum={H[`${t}CS_NOTE`].r}
                    maxlen={1000}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_CS.r} />
        </div>
      )}
    </div>
  );
};
